export default {
  seeAll: {
    en: 'See all',
  },
}
